import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3b026d32&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b026d32",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3b026d32')) {
      api.createRecord('3b026d32', component.options)
    } else {
      api.reload('3b026d32', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3b026d32&scoped=true", function () {
      api.rerender('3b026d32', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/stock/transfer/logic/index.vue"
export default component.exports